<template>
  <div class="input" :class="classList">
    <div class="input__frame">
      <input :disabled="disabled"
             :value="value"
             @input="input"
             @focus="isFocused = true"
             @blur="isFocused = false"
             v-on="listeners"
             v-bind="$attrs"
             class="input__control"
             :class="{
               'input__control--disabled': disabled,
               'input__control--filled': !isEmpty,
               'input__control--focused': isFocused,
               'input__control--error': this.error
             }"
      >
      <div class="input__placeholder" :class="isFocused || !isEmpty ? 'input__placeholder--outside' : 'input__placeholder--inside'">
        {{ placeholder }}
      </div>
    </div>
    <div class="input__messages">
      <div class="input__hint input__message" v-if="hint" v-html="hint"></div>
      <div class="input__error input__message" v-if="error" v-html="error"></div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      block: { type: Boolean, default: false },
      placeholder: { default: 'Placeholder' },
      disabled: { type: Boolean, default: false },
      value: {},
      error: { type: String, default: '' },
      hint: { type: String, default: '' }
    },
    data () {
      return {
        isFocused: false
      }
    },
    methods: {
      input (e) {
        this.$emit('input', e.target.value)
      }
    },
    computed: {
      isEmpty () {
        return this.value === '' || this.value === null || this.value === undefined
      },
      listeners () {
        const { ...listeners } = this.$listeners
        delete(listeners.input)
        return listeners
      },
      classList () {
        return {
          'input--block': this.block,
          'input--error': this.error,
          'input--disabled': this.disabled
        }
      },
    }
  }
</script>

<style lang="scss">
  .input {
    padding-top: 18px;
    display: inline-block;
  }

  .input--disabled {
    pointer-events: none;
    opacity: 0.7;
  }

  .input--block {
    width: 100%;
  }

  .input__frame {
    position: relative;
    display: block;
  }

  .input__control {
    display: block;
    width: 100%;
    background: none;
    border-radius: 0;
    padding: 11px 0;
    font-family: inherit;
    font-size: 16px;
    line-height: 16px;
    height: 38px;
    color: inherit;
    border: 0;
    outline: none;
    border-bottom: 1px solid $color-blue;

    &::placeholder {
      font-family: inherit;
      font-size: 16px;
      line-height: 16px;
      color: rgba($color-blue, 0);
    }
  }

  .input__control--filled {
    color: $color-cyan;
  }

  .input__control--focused {
    border-color: #fff;
    color: #fff;
  }

  .input__control--error {
    border-color: $color-red;
    color: #fff
  }

  .input__placeholder {
    position: absolute;
    left: 0;
    top: 0;
    color: rgba($color-blue, 0.59);
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    padding: 11px 0;
    pointer-events: none;
    line-height: 16px;
    transition: 0.15s transform ease, 0.15s font-size;
  }

  .input__placeholder--inside {
    font-size: 16px;
    transform: translateY(0);
  }

  .input__placeholder--outside {
    font-size: 12px;
    transform: translateY(-28px)
  }

  .input__messages {
    margin-top: 8px;
  }

  .input__message {
    margin-bottom: 4px;
    font-size: 12px;
    line-height: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .input__hint {
    color: $color-blue
  }

  .input__error {
    color: $color-red
  }
</style>
